import { Box, Button } from "@mui/material";
import { useUpdateVisitResourceStatusMutation, VisitResourceVirtualProviderStatusEnum } from "~/graphql/__generated__/graphql";

interface Props {
  visitResourceId: number;
  visitId: number;
  currentStatus?: VisitResourceVirtualProviderStatusEnum | null;
}

/**
 * DEBUG ONLY: Buttons to manually set virtual provider status
 * Remove this component before production!
 */
export default function DebugSetNotifiedButton({ visitResourceId, visitId, currentStatus }: Props) {
  const [updateStatus, { loading }] = useUpdateVisitResourceStatusMutation();

  const handleStatusChange = async (newStatus: VisitResourceVirtualProviderStatusEnum) => {
    await updateStatus({
      variables: {
        id: visitResourceId,
        visitId: visitId,
        newStatus: newStatus,
      },
      refetchQueries: "active",
    });
    alert(`Status set to ${newStatus}!`);
  };

  // @ts-expect-error - window.debugMode is a global variable
  if (!window.debugMode) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, ml: 1 }}>
      {currentStatus !== VisitResourceVirtualProviderStatusEnum.Notified && (
        <Button
          onClick={() => handleStatusChange(VisitResourceVirtualProviderStatusEnum.Notified)}
          loading={loading}
          color="warning"
          variant="outlined"
          size="small"
        >
          [DEBUG] Reset to Notified
        </Button>
      )}
      {currentStatus !== VisitResourceVirtualProviderStatusEnum.Joined && (
        <Button
          onClick={() => handleStatusChange(VisitResourceVirtualProviderStatusEnum.Joined)}
          loading={loading}
          color="info"
          variant="outlined"
          size="small"
        >
          [DEBUG] Set Joined
        </Button>
      )}
      {currentStatus !== VisitResourceVirtualProviderStatusEnum.Complete && (
        <Button
          onClick={() => handleStatusChange(VisitResourceVirtualProviderStatusEnum.Complete)}
          loading={loading}
          color="success"
          variant="outlined"
          size="small"
        >
          [DEBUG] Set Complete
        </Button>
      )}
    </Box>
  );
}
